<script setup></script>

<template>
  <div
    class="typo-xl! rounded-br-sm-md! rounded-tl-sm-md! rounded-tr-sm-md! mb-3 bg-white/60 px-7 py-6"
  >
    <slot />
  </div>
</template>
